import { render, staticRenderFns } from "./LiquidacionCompra.vue?vue&type=template&id=56345718&lang=pug&"
import script from "./LiquidacionCompra.vue?vue&type=script&lang=js&"
export * from "./LiquidacionCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports